<template>
  <div class="ue-coal-edit">
    <el-card>
      <div class="header d-flex justify-content-between align-items-center mb-3">
        <h2>Уголь ДТ (Год: {{ formData.trancheYear }})</h2>
        <div>
          <el-button @click="goBack" class="ms-2">Назад</el-button>
          <el-button type="primary" @click="saveData" :loading="saving" v-if="formData.status !== 'APPROVED' && hasAccess(editRoles)">Сохранить</el-button>
        </div>
      </div>

      <div class="table-container mb-3" style="overflow-x: auto;" @paste="handlePaste" @keydown="handleKeydown">
        <table class="table table-bordered grid-table">
          <thead>
            <tr>
              <th rowspan="2">Вид топлива</th>
              <th rowspan="2">Необходимый объем топлива (тонн)</th>
              <th rowspan="2">Стоимость топлива за единицу</th>
              <th rowspan="2">Всего</th>
              <th colspan="12" style="padding: 0;">в т.ч. по месяцам</th>
              <th rowspan="2" v-if="formData.status !== 'APPROVED' && hasAccess(editRoles)"></th>
            </tr>
            <tr>
              <th>янв</th>
              <th>фев</th>
              <th>мар</th>
              <th>апр</th>
              <th>май</th>
              <th>июн</th>
              <th>июл</th>
              <th>авг</th>
              <th>сен</th>
              <th>окт</th>
              <th>ноя</th>
              <th>дек</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-success fw-bold">
              <td>Всего:</td>
              <td></td>
              <td></td>
              <td>{{ formatNumber(totalCalculated) }}</td>
              <td>{{ formatNumber(totalMonths[0]) }}</td>
              <td>{{ formatNumber(totalMonths[1]) }}</td>
              <td>{{ formatNumber(totalMonths[2]) }}</td>
              <td>{{ formatNumber(totalMonths[3]) }}</td>
              <td>{{ formatNumber(totalMonths[4]) }}</td>
              <td>{{ formatNumber(totalMonths[5]) }}</td>
              <td>{{ formatNumber(totalMonths[6]) }}</td>
              <td>{{ formatNumber(totalMonths[7]) }}</td>
              <td>{{ formatNumber(totalMonths[8]) }}</td>
              <td>{{ formatNumber(totalMonths[9]) }}</td>
              <td>{{ formatNumber(totalMonths[10]) }}</td>
              <td>{{ formatNumber(totalMonths[11]) }}</td>
              <td v-if="formData.status !== 'APPROVED' && hasAccess(editRoles)"></td>
            </tr>
            <tr v-for="(item, index) in formData.details" :key="item.uuid || index">
              <td style="min-width: 220px;">
                <el-select v-model="item.fuelGroup" placeholder="Тип" size="small" style="width: 100%; margin-bottom: 4px;" @change="onFuelGroupChange(item)">
                  <el-option label="Твердое" value="SOLID"></el-option>
                  <el-option label="Жидкое" value="LIQUID"></el-option>
                </el-select>
                <el-select v-if="item.fuelGroup" v-model="item.dictFuelTypeId" placeholder="Вид топлива" size="small" style="width: 100%;">
                  <el-option v-for="f in getSubtypes(item.fuelGroup)" :key="f.id" :label="f.label" :value="f.id" :disabled="isSubtypeUsed(f.id, item)"></el-option>
                </el-select>
              </td>
              <td :data-item-idx="index" data-col="1"><el-input v-model="item.count" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" /></td>
              <td :data-item-idx="index" data-col="2"><el-input v-model="item.costPerUnit" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" /></td>
              <td class="text-center align-middle" style="background-color: var(--el-fill-color-light); color: var(--el-text-color-regular);">{{ formatNumber(item.calculatedSum) }}</td>
              <td :data-item-idx="index" data-col="4"><el-input v-model="item.janSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="5"><el-input v-model="item.febSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="6"><el-input v-model="item.marSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="7"><el-input v-model="item.aprSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="8"><el-input v-model="item.maySum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="9"><el-input v-model="item.junSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="10"><el-input v-model="item.julSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="11"><el-input v-model="item.augSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="12"><el-input v-model="item.sepSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="13"><el-input v-model="item.octSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="14"><el-input v-model="item.novSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="15"><el-input v-model="item.decSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td v-if="formData.status !== 'APPROVED' && hasAccess(editRoles)">
                <el-button type="danger" size="small" @click="removeRow(index)">
                  <font-awesome-icon :icon="['fas', 'trash']" />
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mb-3" v-if="formData.status !== 'APPROVED' && hasAccess(editRoles) && canAddRow">
        <el-button type="success" size="small" @click="addRow">
          <font-awesome-icon :icon="['fas', 'plus']"/> Добавить строку
        </el-button>
      </div>

    </el-card>
    <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
  </div>
</template>

<script>
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import ueCoalDtService from "@/services/ueCoalDtService";
import authService from "@/services/authService";
import {handleGridKeydown} from "@/utils/gridKeyboardNav";

const FUEL_SUBTYPES = {
  SOLID: [
    { id: 4, label: 'Уголь' },
    { id: 5, label: 'Дрова' },
  ],
  LIQUID: [
    { id: 1, label: 'Бензин' },
    { id: 2, label: 'Дизельное топливо' },
    { id: 3, label: 'Газ' },
  ]
};
const ALL_FUEL_IDS = Object.values(FUEL_SUBTYPES).flat().map(s => s.id);

const MAX_ROWS = 5;

export default {
  name: "UeCoalDtEditView",
  components: { VueLoading },
  data() {
    return {
      isLoading: false,
      saving: false,
      uuid: this.$route.params.uuid,
      formData: {
        details: []
      },
      editRoles: ['ROLE_VO_UNIVERSITY', 'ROLE_VO_ADMIN', 'ROLE_VO_MANAGER']
    };
  },
  computed: {
    totalCalculated() {
      return this.formData.details.reduce((sum, item) => sum + (parseFloat(item.calculatedSum) || 0), 0);
    },
    totalActual() {
      return this.formData.details.reduce((sum, item) => sum + (parseFloat(item.actualSum) || 0), 0);
    },
    canAddRow() {
      return this.formData.details.length < MAX_ROWS;
    },
    totalMonths() {
      const totals = [0,0,0,0,0,0,0,0,0,0,0,0];
      this.formData.details.forEach(item => {
        totals[0] += parseFloat(item.janSum) || 0;
        totals[1] += parseFloat(item.febSum) || 0;
        totals[2] += parseFloat(item.marSum) || 0;
        totals[3] += parseFloat(item.aprSum) || 0;
        totals[4] += parseFloat(item.maySum) || 0;
        totals[5] += parseFloat(item.junSum) || 0;
        totals[6] += parseFloat(item.julSum) || 0;
        totals[7] += parseFloat(item.augSum) || 0;
        totals[8] += parseFloat(item.sepSum) || 0;
        totals[9] += parseFloat(item.octSum) || 0;
        totals[10] += parseFloat(item.novSum) || 0;
        totals[11] += parseFloat(item.decSum) || 0;
      });
      return totals;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    hasAccess(roles) {
      return authService.hasAccess(roles);
    },
    formatNumber(val) {
      if (val === undefined || val === null || val === '' || isNaN(val)) return '0,00';
      const formatted = parseFloat(val).toFixed(2);
      const parts = formatted.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    },
    formatInputNumber(value) {
      if (value === undefined || value === null || value === '') return '';
      const parts = value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    },
    parseInputNumber(value) {
      if (!value) return '';
      let parsed = value.toString().replace(',', '.');
      parsed = parsed.replace(/[^\d.]/g, '');
      const parts = parsed.split('.');
      if (parts.length > 2) {
        parsed = parts[0] + '.' + parts.slice(1).join('');
      }
      return parsed;
    },
    async loadData() {
      if (!this.uuid) return;
      this.isLoading = true;
      try {
        const data = await ueCoalDtService.getById(this.uuid);
        if (data) {
          if (!data.details) data.details = [];
          data.details.forEach(item => {
            item.fuelGroup = this.detectFuelGroup(item.dictFuelTypeId);
          });
          this.formData = data;
        }
      } catch (e) {
        showErrorNotify('Ошибка при загрузке данных');
      } finally {
        this.isLoading = false;
      }
    },
    recalcTotal(item) {
      const months = ["janSum", "febSum", "marSum", "aprSum", "maySum", "junSum", "julSum", "augSum", "sepSum", "octSum", "novSum", "decSum"];
      const sum = months.reduce((acc, m) => acc + (parseFloat(item[m]) || 0), 0);
      item.calculatedSum = sum.toFixed(2);
      item.totalSum = sum.toFixed(2);
    },
    getSubtypes(group) {
      return FUEL_SUBTYPES[group] || [];
    },
    detectFuelGroup(fuelTypeId) {
      if (!fuelTypeId) return null;
      for (const [group, subtypes] of Object.entries(FUEL_SUBTYPES)) {
        if (subtypes.some(s => s.id === fuelTypeId)) return group;
      }
      return null;
    },
    onFuelGroupChange(item) {
      item.dictFuelTypeId = null;
    },
    isSubtypeUsed(fuelId, currentItem) {
      return this.formData.details.some(d => d !== currentItem && d.dictFuelTypeId === fuelId);
    },
    addRow() {
      if (this.formData.details.length >= MAX_ROWS) return;
      this.formData.details.push({
        fuelGroup: null,
        dictFuelTypeId: null,
        count: '',
        costPerUnit: '',
        calculatedSum: '',
        actualSum: '',
        totalSum: '',
        janSum: '', febSum: '', marSum: '', aprSum: '',
        maySum: '', junSum: '', julSum: '', augSum: '',
        sepSum: '', octSum: '', novSum: '', decSum: ''
      });
    },
    removeRow(index) {
      if (confirm('Удалить строку?')) {
        this.formData.details.splice(index, 1);
      }
    },
    async saveData() {
      this.saving = true;
      try {
        const result = await ueCoalDtService.save(this.formData);
        if (result.details) {
          result.details.forEach(item => {
            item.fuelGroup = this.detectFuelGroup(item.dictFuelTypeId);
          });
        }
        this.formData = result;
        showSuccessNotify('Данные успешно сохранены');
      } catch (e) {
        showErrorNotify('Ошибка при сохранении');
      } finally {
        this.saving = false;
      }
    },
    goBack() {
      this.$router.push('/expenses/coal');
    },
    handleKeydown(event) {
      handleGridKeydown(event, this.$el);
    },
    handlePaste(event) {
      const target = event.target;
      if (!target || target.tagName !== 'INPUT') return;

      const td = target.closest('td');
      if (!td) return;

      const startItemIdx = parseInt(td.dataset.itemIdx);
      const startCol = parseInt(td.dataset.col);

      if (isNaN(startItemIdx) || isNaN(startCol)) return;

      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      const text = clipboardData.getData('text/plain');
      if (!text) return;

      const rows = text.split(/\r?\n/).filter(r => r.trim() !== '');
      if (rows.length <= 1 && !rows[0].includes('\t')) return;

      event.preventDefault();

      const COL_FIELDS = [
        'SKIP', 'count', 'costPerUnit', 'SKIP',
        'janSum', 'febSum', 'marSum', 'aprSum', 'maySum', 'junSum',
        'julSum', 'augSum', 'sepSum', 'octSum', 'novSum', 'decSum'
      ];

      let currentItemIdx = startItemIdx;

      for (let r = 0; r < rows.length; r++) {
        const cols = rows[r].split('\t');
        
        if (currentItemIdx >= this.formData.details.length) break;
        let currentItem = this.formData.details[currentItemIdx];

        for (let c = 0; c < cols.length; c++) {
          const colIdx = startCol + c;
          if (colIdx >= COL_FIELDS.length) break;

          const field = COL_FIELDS[colIdx];
          if (field === 'SKIP') continue;

          const rawVal = String(cols[c]).replace(/\s/g, '').replace(',', '.');
          
          const num = parseFloat(rawVal);
          currentItem[field] = isNaN(num) || num === 0 ? '' : num;
        }

        this.recalcTotal(currentItem);
        currentItemIdx++;
      }

      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.grid-table th { 
  font-size: 13px; 
  vertical-align: middle; 
  text-align: center; 
}
.grid-table td { 
  font-size: 13px;
  vertical-align: middle; 
}
.calculated-row {
  background-color: #e8f5e9 !important;
}
:deep(.el-input__inner) {
  font-size: 13px;
}
:deep(.el-select .el-input__inner) {
  font-size: 13px;
}
</style>
